import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos";
import { MobileWeb } from "../mobile/BreakPoint";
import { Theme } from "@mui/material";

interface IYoutubeSlider {
  autoPlay?: boolean;
  animation?: "fade" | "slide";
  indicators?: boolean;
  duration?: number;
  navButtonsAlwaysVisible?: boolean;
  navButtonsAlwaysInvisible?: boolean;
  fullHeightHover?: boolean;
  cycleNavigation?: boolean;
  swipe?: boolean;
  [key: string]: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  slideBox: {
    maxWidth: "1000px",
    display: "block",
    height: "600px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  project: {
    // maxWidth: "100%",
    width: "855px",
    position: "relative",
    height: "300px",
    overflow: "hidden",
    // padding: "20px",
    color: "white",
    left: "72px",
  },
  checkButton: {
    marginTop: "40px",
    color: "white",
    fontSize: "16px",
    border: "3px solid white",
    textTransform: "capitalize",
  },
  nextBtn: {
    right: "100px",
  },
  arrowLeft: {
    fontSize: "105px",
    width: "80px",
    position: "relative",
    left: "-20px",
  },
  arrowRight: {
    fontSize: "105px",
    width: "80px",
    position: "relative",
    left: "20px",
  },
}));

const EPromoteSlider1 = (props: IYoutubeSlider) => {
  const classes = useStyles();

  return (
    <div
      style={{
        width: "1000px",
        left: "0px",
        position: "relative",
        marginTop: "12px",
        color: "#494949",
      }}
    >
      <Carousel
        className={classes.slideBox}
        autoPlay={false}
        animation="slide"
        indicators={false}
        duration={500}
        navButtonsAlwaysVisible={false}
        navButtonsAlwaysInvisible={true}
        cycleNavigation={true}
        fullHeightHover={false}
        swipe={true}
        NextIcon={
          <ArrowForwardIcon
            style={{
              fontSize: "105px",
              width: "80px",
              position: "relative",
              left: "20px",
            }}
          />
        }
        PrevIcon={
          <ArrowBackIcon
            style={{
              fontSize: "105px",
              width: "80px",
              position: "relative",
              left: "-20px",
            }}
          />
        }
        navButtonsProps={{
          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
          style: {
            backgroundColor: "transparent",
            borderRadius: 0,
          },
        }}
        navButtonsWrapperProps={{
          // Move the buttons to the bottom. Unsetting top here to override default style.
          style: {
            padding: "10px",
            top: "185px",
          },
        }}
      >
        {items.map((item, index) => {
          return <Project item={item} key={index} />;
        })}
      </Carousel>

      <br />
    </div>
  );
};

type Item = {
  name?: string;
  description?: string;
  color?: string;
  href?: any;
  content?: any;
};

interface ProjectProps {
  item: Item;
}

function Project({ item }: ProjectProps) {
  const classes = useStyles();

  console.log("??", item);

  return (
    <div>
      <Paper
        className={classes.project}
        style={{
          backgroundColor: item.color,
          boxShadow: "none",
          height: "600px",
        }}
        elevation={10}
      >
        {item.href}
        {item.content}
      </Paper>
    </div>
  );
}

const items: Item[] = [
  {
    name: "",
    description: "",
    color: "orange",
    href: (
      <iframe
        src="https://www.youtube.com/embed/t4B73Qr_X2Y"
        width="100%"
        height="100%"
        title="bilibili1"
        allowFullScreen
      />
    ),
    content: "",
  },
];

export default EPromoteSlider1;
